import React from "react";
import mapServiceItem from "./mapServiceItem";
import import1 from "../assets/produccion-4.jpg";
import import2 from "../assets/produccion-5.jpg";
import lanzamientosImage from "../assets/lanzamientos.png";

const eventImages = [
    "https://images.unsplash.com/photo-1587825140708-dfaf72ae4b04?w=800&q=80",
    "https://images.unsplash.com/photo-1505373877841-8d25f7d46678?w=800&q=80",
    lanzamientosImage,
    import2,
    "https://images.unsplash.com/photo-1475721027785-f74eccf877e2?w=800&q=80",
    import1,
];

export default function ProductionEvents({ items }) {
    return (
        <div className="production-events">
            {items.map((item, index) => {
                const card = mapServiceItem(item);

                return (
                    <article className="production-event-card" key={card.title}>
                        <img src={eventImages[index]} alt={card.title} />
                        <div>
                            <span>{card.marker}</span>
                            <h3>{card.title}</h3>
                            <p>{card.text}</p>
                        </div>
                    </article>
                );
            })}
        </div>
    );
}
